import React from "react";
import ButtonCell from "../buttons/ButtonCell";
import { RuleItem } from "../../interfaces/RuleItem";
import { RuleModuleType } from "../../constants/constants";
import { RuleModuleContext } from "../../contexts/RuleModuleContext";
import FormWithNameAndKey from "./FormWithNameAndKey";
import { ActionResult } from "../../interfaces/ActionResult";

export default () => {
  const { addItem, ruleItemName, moduleType, key } = React.useContext(
    RuleModuleContext
  );
  const [started, setStarted] = React.useState(false);
  const [newRuleItemName, setNewRuleItemName] = React.useState("");
  const [newRuleItemKey, setNewRuleItemKey] = React.useState("");

  const resetState = (start: boolean) => {
    setStarted(start);
    setNewRuleItemName("");
    setNewRuleItemKey("");
  };

  const addItemAndReset = () => {
    const newRuleItem: RuleItem = {
      name: newRuleItemName,
      key: newRuleItemKey,
      details: {},
    };
    const result: ActionResult = addItem(newRuleItem);
    if (!result.success) {
      alert(result.message);
      return;
    }
    setStarted(false);
  };

  return (
    <FormWithNameAndKey
      started={started}
      dataTest={`add-rule-item-${key}`}
      resetState={resetState}
      setItemName={setNewRuleItemName}
      setItemKey={setNewRuleItemKey}
      typeName={ruleItemName}
    >
      <ButtonCell
        dataTest={`add-rule-item-${key}`}
        buttonText="Add"
        classes={
          [
            RuleModuleType.ItemOnly,
            RuleModuleType.ItemAndSource,
            RuleModuleType.SelectAndRank,
            RuleModuleType.SelectOnly,
          ].includes(moduleType)
            ? "grid-cell-fill"
            : ""
        }
        onClick={addItemAndReset}
      />
    </FormWithNameAndKey>
  );
};
